import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["knob", "button", "labelMonthly", "labelYearly", "amount", "period", "priceId"]

  connect() {
    this.isYearly = false
  }

  toggle() {
    this.isYearly = !this.isYearly

    this.knobTarget.style.transform = this.isYearly ? "translateX(1.75rem)" : "translateX(0)"
    this.buttonTarget.classList.toggle("bg-primary", this.isYearly)
    this.buttonTarget.classList.toggle("bg-base-300", !this.isYearly)

    this.labelMonthlyTarget.style.fontWeight = this.isYearly ? "500" : "600"
    this.labelMonthlyTarget.style.opacity = this.isYearly ? "0.5" : "1"

    this.labelYearlyTarget.style.fontWeight = this.isYearly ? "600" : "500"
    this.labelYearlyTarget.style.opacity = this.isYearly ? "1" : "0.5"

    const period = this.isYearly ? "yearly" : "monthly"
    this.amountTargets.forEach((el) => {
      el.textContent = el.dataset[period]
    })
    this.periodTargets.forEach((el) => {
      el.textContent = el.dataset[period]
    })
    this.priceIdTargets.forEach((el) => {
      el.value = el.dataset[period]
    })
  }
}
